import { EPatientStatusNumeric } from '@mybonum/api';

export const PATIENT_STATUS_MAP = new Map<EPatientStatusNumeric, string>([
    [EPatientStatusNumeric.Active, 'Active'],
    [EPatientStatusNumeric.Inactive, 'Inactive'],
]);
